import React, {ReactNode} from "react";
import {FileRead} from "../../../../declarations";
import {downloadFileVariables} from "../../../../helpers";
import {Container, Divider, LoadingCenter, Text} from "../../../../ui";
import {CustomDialog, Link} from "../../../bounce-ui";
import {AccountBase} from "../../../declarations";
import {AccountDocumentations} from "../account-documentations";
import {DetailsSection} from "./DetailsSection";
import {DisputeLinks} from "./DisputeLinks";

interface IAccountDetailsContent {
  title: string;
  cancelHandler: () => void;
  account?: AccountBase;
  isLoading: boolean;
  userFiles?: FileRead[];
  isInCampaign: boolean;
  breakdownView: boolean;
  setBreakdownView: (value: boolean) => void;
  handleFileDispute?: () => void;
  handleVerificationRequest?: () => void;
  downloadUserFiles: (variables: downloadFileVariables) => Promise<void | string>;
  AccountMainDetails: ReactNode;
  BalanceBreakdown: ReactNode;
  showDisputeLink?: boolean;
  onResolve?: (e: React.MouseEvent) => void;
}

export const AccountDetailsContent = ({
  title,
  cancelHandler,
  account,
  isLoading,
  userFiles,
  isInCampaign,
  breakdownView,
  setBreakdownView,
  handleFileDispute,
  handleVerificationRequest,
  downloadUserFiles,
  AccountMainDetails,
  BalanceBreakdown,
  showDisputeLink = false,
  onResolve,
}: IAccountDetailsContent) => {
  return (
    <CustomDialog title={title} onClose={cancelHandler}>
      <Container
        sx={{
          width: "300px",
          height: "460px",
        }}
      >
        {!account || isLoading ? (
          <LoadingCenter />
        ) : (
          <Container
            fullWidth
            sx={{
              alignItems: "start",
              gap: "20px",
              overflowY: "auto",
              flex: 1,
            }}
          >
            <Container fullWidth sx={{alignItems: "start", gap: "5px"}}>
              {AccountMainDetails}
            </Container>
            <Container fullWidth sx={{padding: "5px", gap: "15px"}}>
              {userFiles && (
                <AccountDocumentations
                  accountId={account.id}
                  openDocuments={isInCampaign}
                  userFiles={userFiles}
                  downloadUserFiles={downloadUserFiles}
                />
              )}
              <DetailsSection title={"Balance breakdown"} isOpen={breakdownView} setIsOpen={setBreakdownView}>
                {BalanceBreakdown}
              </DetailsSection>
              <Divider fullWidth />
            </Container>
            <Container fullWidth sx={{alignItems: "start"}}>
              {onResolve && (
                <Container fullWidth sx={{alignItems: "start", gap: 0}}>
                  <Text size={14} fontWeight={500}>
                    Want to resolve balances one at a time?
                  </Text>
                  <Link onClick={onResolve} size={14}>
                    Resolve just this balance
                  </Link>
                </Container>
              )}
              {showDisputeLink && handleFileDispute && handleVerificationRequest && (
                <DisputeLinks
                  handleFileDispute={handleFileDispute}
                  handleVerificationRequest={handleVerificationRequest}
                />
              )}
            </Container>
          </Container>
        )}
      </Container>
    </CustomDialog>
  );
};
